module.exports = __webpack_public_path__ + "static/redcurrant-b92d0c87182fd41e61e1a79e743fa8f3.svg";